import { Box, Container, Typography } from "@mui/material";
import { QuoteButton } from "../../../components/QuoteButton";

export function CtaBanner() {
  return (
    <Box component="section" sx={{ py: { xs: 10, md: 16 } }}>
      <Container maxWidth="md">
        <Box
          sx={{
            textAlign: "center",
            px: { xs: 3, md: 8 },
            py: { xs: 7, md: 10 },
            borderRadius: 6,
            border: "1px solid",
            borderColor: "divider",
            background: (theme) =>
              `radial-gradient(ellipse at top, ${theme.palette.primary.main}33 0%, transparent 70%), #121212`,
          }}
        >
          <Typography variant="h2" sx={{ fontSize: { xs: "2rem", md: "2.75rem" } }}>
            Vamos tornar o seu evento inesquecível?
          </Typography>
          <Typography sx={{ mt: 2, mx: "auto", maxWidth: 520, color: "text.secondary", lineHeight: 1.7 }}>
            Conte para a gente a data e o tipo de evento e receba uma proposta.
          </Typography>
          <QuoteButton size="large" sx={{ mt: 5, px: 5, py: 1.5 }} />
        </Box>
      </Container>
    </Box>
  );
}
